export enum RoutesList {
  DASHBOARD = 'dashboard',
  AUCTION = 'auction'
}